var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSplitRole(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 27,
    viewBox: "0 0 47 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.5 2.5H28.5M33.5 24.5H28.5M28.25 2.5L28.25 24.5",
    stroke: "#1F4B82",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 2.5H18.5M13.5 24.5H18.5M18.75 2.5L18.75 24.5",
    stroke: "#1F4B82",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.620671 14.2632C0.476815 14.1172 0.476815 13.8828 0.620671 13.7368L6.61701 7.65162C6.85244 7.4127 7.25912 7.57941 7.25912 7.91483L7.25912 20.0852C7.25912 20.4206 6.85244 20.5873 6.61701 20.3484L0.620671 14.2632Z",
    fill: "#AD2F2F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.50365 11.7839C3.50365 11.5768 3.67154 11.4089 3.87865 11.4089H14.3431C14.7059 11.4089 15 11.3704 15 11.7763V15.8101C15 16.0172 14.8321 16.1851 14.625 16.1851C14.5604 16.1851 14.48 16.1851 14.3431 16.1851H3.87865C3.67154 16.1851 3.50365 16.0172 3.50365 15.8101V11.7839Z",
    fill: "#AD2F2F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M46.3793 14.2632C46.5232 14.1172 46.5232 13.8828 46.3793 13.7368L40.383 7.65162C40.1476 7.4127 39.7409 7.57941 39.7409 7.91483L39.7409 20.0852C39.7409 20.4206 40.1476 20.5873 40.383 20.3484L46.3793 14.2632Z",
    fill: "#AD2F2F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M43.4964 11.7839C43.4964 11.5768 43.3285 11.4089 43.1214 11.4089H32.6569C32.2941 11.4089 32 11.3704 32 11.7763V15.8101C32 16.0172 32.1679 16.1851 32.375 16.1851C32.4396 16.1851 32.52 16.1851 32.6569 16.1851H43.1214C43.3285 16.1851 43.4964 16.0172 43.4964 15.8101V11.7839Z",
    fill: "#AD2F2F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSplitRole);
export default __webpack_public_path__ + "static/media/split_role.d2efe2dfb36bab69adbac7b5113db8c3.svg";
export { ForwardRef as ReactComponent };